import "./AboutCenter.module.css";
import Header from "@/reusable_sections/Header";
import VisionPhilosophie from "./sections/VisionPhilosophie";
import WurzelnGeschichte from "./sections/WurzelnGeschichte";
import BerbrCkungWissenschaftTrifftTradition from "./sections/BerbrCkungWissenschaftTrifftTradition";
import UnserFHrungsteam from "./sections/UnserFHrungsteam";
import Footer from "@/reusable_sections/Footer";
export default function AboutCenterPage() {
  return <div>
      <Header />
      <VisionPhilosophie />
      <WurzelnGeschichte />
      <BerbrCkungWissenschaftTrifftTradition />
      <UnserFHrungsteam />
      <Footer />
    </div>;
}